(function () {
  'use strict';

  const assetPromises = {};

  function loadStyle(key, href) {
    if (assetPromises[key]) return assetPromises[key];

    assetPromises[key] = new Promise(function (resolve, reject) {
      const existing = document.querySelector('link[data-zahler-asset="' + key + '"]');
      if (existing) {
        if (existing.sheet) resolve();
        else existing.addEventListener('load', resolve, { once: true });
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.fetchPriority = 'low';
      link.dataset.zahlerAsset = key;
      link.addEventListener('load', resolve, { once: true });
      link.addEventListener('error', reject, { once: true });
      document.head.appendChild(link);
    });

    return assetPromises[key];
  }

  function loadScript(key, src, isReady) {
    if (typeof isReady === 'function' && isReady()) return Promise.resolve();
    if (assetPromises[key]) return assetPromises[key];

    assetPromises[key] = new Promise(function (resolve, reject) {
      const existing = document.querySelector('script[data-zahler-asset="' + key + '"]');
      if (existing) {
        if (typeof isReady === 'function' && isReady()) resolve();
        else existing.addEventListener('load', resolve, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.fetchPriority = 'low';
      script.dataset.zahlerAsset = key;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return assetPromises[key];
  }

  function whenNearViewport(element, callback, rootMargin) {
    if (!element || typeof callback !== 'function') return;

    let started = false;
    const runOnce = function () {
      if (started) return;
      started = true;
      Promise.resolve(callback()).catch(function (error) {
        console.warn('Zahler deferred section failed to initialize.', error);
      });
    };

    if ((window.Shopify && Shopify.designMode) || !('IntersectionObserver' in window)) {
      runOnce();
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        runOnce();
      }
    }, { rootMargin: rootMargin || '150px 0px' });

    observer.observe(element);
  }

  window.zahlerPerformance = {
    whenNearViewport: whenNearViewport,
    loadSlick: function () {
      return loadScript(
        'jquery-js',
        'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js',
        function () { return Boolean(window.jQuery); }
      ).then(function () {
        return Promise.all([
          loadStyle('slick-css', 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css'),
          loadScript('slick-js', 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js', function () {
            return window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function';
          })
        ]);
      });
    },
    loadSwiper: function () {
      return Promise.all([
        loadStyle('swiper-css', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'),
        loadScript('swiper-js', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js', function () {
          return typeof window.Swiper === 'function';
        })
      ]);
    }
  };
})();
